import Icon from '../components/Icon.vue'

Icon.register({
  archive: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 448v-288h448v288c0 17.7-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32zM192 236v8c0 6.6 5.4 12 12 12h104c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-104c-6.6 0-12 5.4-12 12zM480 32c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-48c0-17.7 14.3-32 32-32h448z'
      }
    ]
  }
})
